/**
 * Skeleton — animated placeholder used while async queries are in
 * flight. Preserves layout so the page does not jump when real
 * data lands.
 *
 * Variants:
 *   <Skeleton />                    — single inline rectangle
 *   <Skeleton lines={3} />          — stacked rectangles
 *   <SkeletonCard />                — a KPI-card-shaped block
 *   <SkeletonRow cells={5} />       — table row
 *   <SkeletonGrid items={6} />      — grid of cards
 */

import React from 'react';
import './Skeleton.css';

export const Skeleton = ({ width, height = 14, radius = 6, style, className = '' }) => (
  <span
    className={`skeleton ${className}`}
    style={{
      width: width || '100%',
      height: typeof height === 'number' ? `${height}px` : height,
      borderRadius: typeof radius === 'number' ? `${radius}px` : radius,
      ...style,
    }}
    aria-hidden="true"
  />
);

export const SkeletonText = ({ lines = 3, lastWidth = '60%' }) => (
  <div className="skeleton-stack">
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton
        key={i}
        height={12}
        width={i === lines - 1 ? lastWidth : '100%'}
      />
    ))}
  </div>
);

export const SkeletonCard = () => (
  <div className="skeleton-card">
    <Skeleton width={36} height={36} radius="50%" />
    <div style={{ flex: 1 }}>
      <Skeleton width="40%" height={10} />
      <div style={{ height: 8 }} />
      <Skeleton width="60%" height={20} />
      <div style={{ height: 6 }} />
      <Skeleton width="30%" height={10} />
    </div>
  </div>
);

export const SkeletonGrid = ({ items = 4 }) => (
  <div className="skeleton-grid">
    {Array.from({ length: items }).map((_, i) => (
      <SkeletonCard key={i} />
    ))}
  </div>
);

export const SkeletonRow = ({ cells = 5 }) => (
  <tr className="skeleton-row" aria-hidden="true">
    {Array.from({ length: cells }).map((_, i) => (
      <td key={i}><Skeleton height={12} width={i === 0 ? '70%' : '50%'} /></td>
    ))}
  </tr>
);

export const SkeletonRows = ({ rows = 4, cells = 5 }) => (
  <>
    {Array.from({ length: rows }).map((_, i) => (
      <SkeletonRow key={i} cells={cells} />
    ))}
  </>
);

export default Skeleton;
